import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { articles } from 'src/app/core/translations/articles';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-article-details',
  templateUrl: './article-details.component.html',
  styleUrls: ['./article-details.component.scss']
})
export class ArticleDetailComponent {
  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';
  currentLanguage: string = '';
  languageTranslations: any = articles;
  activeLanguageTranslations: any = {};
  repeatArticalCard: any = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];
  
  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private storage: StorageService,
  ) {}

  ngOnInit(): void {
    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');
      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
        // console.log(this.activeLanguageTranslations);
      }
    }
  }
  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
  fetchLanguage(): string | null {
    return this.storage.get('language');
  }
  goBackToArticlePage(): void {
    if (this.fetchLanguage() === 'en') {
      this.currentLanguage = 'english';
      this.router.navigate(['/info/english/articles']);
    // } else if (this.fetchLanguage() === 'panjabi') {
    } else {
      this.currentLanguage = 'panjabi';
      this.router.navigate(['/info/panjabi/articles']);
    } 
  }
  gotoTeamsPage(Author: any): void {
    // Logic to open the article, e.g., navigate to a detailed view
    console.log('Opening article:', Author);
    if (this.fetchLanguage() === 'en') {
      this.currentLanguage = 'english';
      this.router.navigate(['/info/english/team/']);
    // } else if (this.fetchLanguage() === 'panjabi') {
    } else {
      this.currentLanguage = 'panjabi';
      this.router.navigate(['/info/panjabi/team']);
    } 
  }
}